import { useEffect, useState } from 'react'

import { getOpportunityNoteById } from '../api'
import { OpportunityNote } from '@user/components/Notes/typings'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const useGetOpportunityNoteOnMount = (noteId: number) => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )
  const [note, setNote] = useState<OpportunityNote | null>(null)

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getOpportunityNoteById(noteId))

        if (mounted) {
          if (getOpportunityNoteById.fulfilled.match(result)) {
            setNote(result.payload)
            setStatus('success')
          } else {
            toast.error('Error loading note.')
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, noteId])

  return [status, note] as const
}
